import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';

function regex(s, disableRegex, caseSensitive) {
  return RegExp(
    disableRegex ? s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&') : s,
    caseSensitive ? 'gu' : 'gui',
  );
}

function processSearches(doc, searchTerm, searchResultClass) {
  let flatText = '';
  const mappings = []; // keeps track of original positions
  doc.descendants((node, pos) => {
    if (node.isText) {
      flatText += node.text;
      for (let i = 0; i < node.text.length; i++) {
        mappings.push(pos + i);
      }
    } else if (node.isBlock) {
      flatText += '\n';
      mappings.push(pos);
    }
  });

  const matches = [...flatText.matchAll(searchTerm)];
  const decorations = [];
  const results = [];

  for (const match of matches) {
    if (match[0] === '') break;

    const start = mappings[match.index];
    const end = mappings[match.index + match[0].length - 1];

    results.push({ from: start, to: end + 1 });
    decorations.push(
      Decoration.inline(start, end + 1, { class: searchResultClass }),
    );
  }

  return {
    decorationsToReturn: DecorationSet.create(doc, decorations),
    results,
  };
}

const CustomSearch = Extension.create({
  name: 'search',

  addOptions() {
    return {
      searchTerm: '',
      results: [],
      searchResultClass: 'search-result',
      caseSensitive: false,
      disableRegex: false,
    };
  },

  addCommands() {
    return {
      setSearchTerm:
        (searchTerm) =>
        ({ state, dispatch }) => {
          this.options.searchTerm = searchTerm;
          this.options.results = [];
          dispatch(state.tr);
          return false;
        },
    };
  },

  addProseMirrorPlugins() {
    const extensionThis = this;

    return [
      new Plugin({
        key: new PluginKey('search'),
        state: {
          init() {
            return DecorationSet.empty;
          },
          apply({ doc, docChanged }) {
            const {
              searchTerm,
              searchResultClass,
              disableRegex,
              caseSensitive,
            } = extensionThis.options;

            if (docChanged || searchTerm) {
              const { decorationsToReturn, results } = processSearches(
                doc,
                regex(searchTerm, disableRegex, caseSensitive),
                searchResultClass,
              );
              extensionThis.options.results = results;
              return decorationsToReturn;
            }
            return DecorationSet.empty;
          },
        },
        props: {
          decorations(state) {
            return this.getState(state);
          },
        },
      }),
    ];
  },
});

export default CustomSearch;
